import StyledSecondaryButton from "../styledSecondaryButton.styled";

const FaqButton = (): React.JSX.Element => {
  const handleClick = () => {
    const win = window.open(
      "https://www.wbstraining.de/faq/?itm_source=userlike&itm_medium=hotlink&itm_campaign=faq",
      "_blank",
    );
    if (win) {
      win.opener = null;
    }
  };

  return (
    <StyledSecondaryButton onClick={handleClick}>
      FAQ: häufige Fragen & Antworten
    </StyledSecondaryButton>
  );
};

export default FaqButton;
